import wixService from '../services/wixService';

export const urlWindow = new URL(window.location.href);
export const GET_SETTINGS = 'get_settings';
export const UPDATE_SETTINGS = 'update_settings';
export const UPDATE_MOBILE_SETTINGS = 'update_mobile_settings';
export const ON_SETTINGS_CHANGE = 'on_settings_change';
export const ON_STYLE_CHANGE = 'on_style_change';
export const IS_APP_LOADING = 'is_app_loading';
export const IS_MOBILE = 'IS_MOBILE';
export const ON_DELETE_APP = 'delete_app';
export const SETTINGS_DATA_URL = urlWindow.origin;
export const SETTINGS_PARAMS_URL = urlWindow.search;
export const SET_COMP_ID = 'SET_COMP_ID';
export const ON_SELECTED_CATEGORY = 'ON_SELECTED_CATEGORY';
export const GET_FAQ_CONTENT = 'GET_FAQ_CONTENT';

export const STYLE_PARAMS = 'style_params';
export const isSiteMode = wixService.isSiteMode();
export const origCompId =
  wixService.getParamFromURL('origCompId') ||
  wixService.Utils.getOrigCompId() ||
  wixService.Utils.getCompId();
export const isMobile = wixService.isMobile();
export const instance = wixService.Utils.getInstance() || 'no instance found';
export const instanceId =
  wixService.Utils.getInstanceId() || 'no instance found';
export const compId =
  wixService.Utils.getOrigCompId() ||
  wixService.getParamFromURL('compId') ||
  wixService.Utils.getCompId();
export const SHOW_LIST = 'show_list';
export const UPDATE_CONTENT = 'update_content';
export const APP_DEF_ID = window.initialState.constants.APP_ID;
export const getWidthElement = (element) => {
  if (element) {
    const style = element.currentStyle || window.getComputedStyle(element),
      width = element.offsetWidth,
      margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight),
      border =
        parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);

    return width + margin + border;
  }
  return 0;
};

export const createDeepLinkURL = function (itemId, cb) {
  wixService.getSiteInfo(function (siteInfo) {
    const siteUrlWithPage =
      siteInfo && siteInfo.url ? siteInfo.url.split('?')[0] : '';
    const siteUrl = siteInfo && siteInfo.baseUrl ? siteInfo.baseUrl : '';
    const url = siteUrlWithPage !== '' ? siteUrlWithPage : siteUrl;
    const splitParam = '?'; // (url.indexOf("?") > -1) ? '&' : '?';
    const deepLinkURL =
      url + splitParam + 'questionId=' + itemId + '&appDefId=' + APP_DEF_ID;
    cb(deepLinkURL);
  });
};
